import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";

const NoData = ({
  src,
  bodyMessage,
  footerMessage,
  minH = false,
}: {
  src: string;
  bodyMessage: string | JSX.Element;
  footerMessage: string | JSX.Element;
  minH?: boolean;
}): JSX.Element => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      gap={9}
      // minH={minH ? "70vh" : "initial"}
      justifyContent="center"
    >
      <Image src={src} alt="no data found" />
      <Text fontSize={[20, 20, 24, 28]} fontWeight={700} textAlign="center">
        {" "}
        {bodyMessage}
      </Text>
      <Text fontSize={[18, 18, 20]} fontWeight={600} textAlign="center">
        {footerMessage}{" "}
      </Text>
    </Flex>
  );
};

export default NoData;
